import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import Theme from 'theme';

// App Routes
import Routes from './Routes';

import { ErrorBoundary } from './helper-components';

const CHAT_WIDGET_SCRIPT_ID = 'subscribili-chat-widget-script';

const normalize = (value) => (value || '').trim().replace(/^['"]|['"]$/g, '');

const App = () => {
  useEffect(() => {
    if (process.env.REACT_APP_CHAT_WIDGET_ENABLED !== 'true') {
      return;
    }

    const scriptUrl = normalize(process.env.REACT_APP_CHAT_WIDGET_SCRIPT_URL);
    const groupId = normalize(process.env.REACT_APP_GROUP_ID);

    if (!scriptUrl || !groupId) {
      return;
    }

    if (document.getElementById(CHAT_WIDGET_SCRIPT_ID)) {
      return;
    }

    // The widget auto-mounts from these data attributes and pulls the group's
    // assistant, greeting, prompts and theme from the backend widget-config.
    const script = document.createElement('script');
    script.id = CHAT_WIDGET_SCRIPT_ID;
    script.src = scriptUrl;
    script.async = true;
    script.dataset.groupId = groupId;
    script.dataset.position = 'bottom-right';
    document.body.appendChild(script);
  }, []);

  return (
    // Boundary to capture error in the Application
    <ErrorBoundary>
      <ThemeProvider theme={Theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />

        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
